module.exports = __webpack_public_path__ + "static/media/IMG_4313.b6b30a39.JPG";